import React from "react";

import MediaCardSection from "./MediaCardSection";

export default function FeaturedArticleMediaCardSection(props) {
	const { additionalData } = props;

	if (!additionalData?.postSummaries?.items) return <>No Post summaries</>;

	return (
		<MediaCardSection data={{ fields: { isContainer: "md", mediaCards: additionalData?.postSummaries?.items } }} />
	);
}
